import { z } from "zod";
import { LocaleSchema } from "./user";
import { ChildSchema, PlusOneSchema } from "./guest";
/**
 * Public RSVP token document — stored at `/rsvpTokens/{token}` where the
 * document ID *is* the secret token.
 *
 * This is a denormalised snapshot: the public RSVP form is unauthenticated
 * and cannot read `/weddings` or `/guests`, so everything it needs to render
 * lives here. The couple's authenticated client (re)writes it when a link is
 * shared and whenever a denormalised field changes — see
 * apps/web/src/features/rsvp/operations.ts.
 */
export const RsvpTokenSchema = z.object({
    /** Mirrors the document id — the secret token. */
    token: z.string(),
    weddingId: z.string(),
    guestId: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    plusOneAllowed: z.boolean().default(false),
    /**
     * The guest's currently-stored companion / children, mirrored so the public
     * form can pre-fill them. Without this the form starts empty and a submit
     * overwrites whatever the couple had already entered (silent data loss).
     * Defaults keep older token docs (written before this field existed) valid.
     */
    plusOne: PlusOneSchema.nullable().default(null),
    children: z.array(ChildSchema).default([]),
    coupleName1: z.string(),
    coupleName2: z.string(),
    weddingDate: z.string().datetime(),
    venue: z.string().nullable().optional(),
    /** Couple's free-text RSVP message (mirrors website content.rsvp). */
    rsvpMessage: z.string().nullable().optional(),
    /** ISO timestamp; after it the form is closed. Null = no deadline. */
    rsvpDeadline: z.string().datetime().nullable().optional(),
    /** Language the public form should render in. */
    locale: LocaleSchema.default("pl"),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
